import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Integrations Fill
 */

export default function IntegrationsFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path d="M8.53333 2.13333C8.53333 2.31848 8.50975 2.69568 8.46542 3.2H12.3C12.5761 3.2 12.8 3.42386 12.8 3.7V6.47481C13.2947 6.42603 13.6721 6.39999 13.8667 6.39999C15.0449 6.39999 16 7.35512 16 8.53333C16 9.71153 15.0449 10.6667 13.8667 10.6667C13.6721 10.6667 13.2947 10.6406 12.8 10.5918V15.5C12.8 15.7761 12.5761 16 12.3 16H8.53333C8.53333 14.8218 7.57821 13.8667 6.4 13.8667C5.22179 13.8667 4.26667 14.8218 4.26667 16H0.5C0.223858 16 0 15.7761 0 15.5V11.7333C1.17821 11.7333 2.13333 10.7782 2.13333 9.6C2.13333 8.42179 1.17821 7.46667 0 7.46667V3.7C0 3.42386 0.223858 3.2 0.5 3.2H4.33459C4.29025 2.69568 4.26667 2.31848 4.26667 2.13333C4.26667 0.955126 5.22179 0 6.4 0C7.57821 0 8.53333 0.955126 8.53333 2.13333Z" />
    </Icon>
  );
}
